<div class="app-content">
  <mat-tab-group>
    <mat-tab>
      <ng-template mat-tab-label>Variables</ng-template>
      <dashboard-variables></dashboard-variables>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>Acquisition Channels</ng-template>
      <dashboard-channels></dashboard-channels>
    </mat-tab>
  </mat-tab-group>
</div>
